"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ConnectionDetail_1 = require("@tableau/vizportal-webclient-api/lib/api/types/ConnectionDetail");
var Localize_1 = require("../../../../gen-src/Localize");
var TextCellFormatter_1 = require("./TextCellFormatter");
var ConnectsToCell = /** @class */ (function (_super) {
    __extends(ConnectsToCell, _super);
    function ConnectsToCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConnectsToCell.prototype.render = function () {
        return (React.createElement(TextCellFormatter_1.TextCellFormatter, { text: this.name(), disabled: this.props.disabled }));
    };
    ConnectsToCell.prototype.name = function () {
        var details = this.props.connectionDetails;
        if (ConnectionDetail_1.ConnectionDetailType.isDatabase(details) || ConnectionDetail_1.ConnectionDetailType.isWebDataDirect(details)) {
            return details.serverName;
        }
        else if (ConnectionDetail_1.ConnectionDetailType.isTableauServer(details)) {
            return details.name || null;
        }
        else if (ConnectionDetail_1.ConnectionDetailType.isFile(details)) {
            return filePathDisplayStringWithBaseNameFirst(details.fileName);
        }
        else {
            return null;
        }
    };
    return ConnectsToCell;
}(React.PureComponent));
exports.ConnectsToCell = ConnectsToCell;
function filePathDisplayStringWithBaseNameFirst(filePath) {
    if (filePath) {
        var lastSeparatorIndex = filePath.lastIndexOf('/');
        if (lastSeparatorIndex < 0) {
            lastSeparatorIndex = filePath.lastIndexOf('\\');
        }
        if (lastSeparatorIndex >= 0) {
            var fileBaseName = filePath.slice(lastSeparatorIndex + 1);
            var fileDirectory = filePath.slice(0, lastSeparatorIndex);
            if (fileDirectory.length > 0) {
                var parenthesizedFileDirectory = Localize_1.Messages.ParenthesizedArgument({ ITEM: fileDirectory });
                return fileBaseName + " " + parenthesizedFileDirectory;
            }
            else {
                return filePath;
            }
        }
    }
    return filePath;
}
//# sourceMappingURL=ConnectsToConnectionsCell.js.map